import React from "react";
import { ConferencingHeader } from "./ConferencingHeader";
import { StreamingHeader } from "./StreamingHeader";
import { isStreamingKit } from "../../common/utils";
import { Flex } from "@100mslive/react-ui";
import Language from "./Language";

export const Header = () => {
  return (
    <Flex
      css={{
        size: "100%",
        padding: "10px",
        justifyContent: "space-between",
        alignItems: "center",
        "@md": { flexDirection: "column", alignItems: "flex-start" },
      }}
    >
      {isStreamingKit() ? <StreamingHeader /> : <ConferencingHeader />}
      <Language />
    </Flex>
  );
};
